"use client"

import RecoveryTable from "@/components/recoverDomain/RecoveryTable";
import { DropdownInterface } from "@/components/ui/dropdown";
import { GetBackups } from "@/services/backup.service";
import { getAllDomains } from "@/services/domains.service";
import { useEffect, useState } from "react";

export interface RecoveryView {
    ID: string,
    Name: string,
    DBRel: string,
    Website: string,
    Folder: string,
    Package: string,
    Backups: DropdownInterface[],
    RecoveryStatus: boolean,
}

export default function RecoveryPage() {
    const [domains, setDomains] = useState<RecoveryView[]>([]);

    const loadAllDomains = async () => {
        const domains = await getAllDomains();
        if(domains.length <= 0){
            setDomains([]);
            return;
        }

        const backupsResult = await GetBackups();
        const arr = domains.map(d => {
            const backups: DropdownInterface[] = backupsResult.filter(backups => backups.DomainId == d.ID).map((backups, index) => {
                return {id: index, value:backups.BackupName, text:backups.BackupName};
            });

            const recoveryView: RecoveryView = {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, Backups: backups, RecoveryStatus: false};
            return recoveryView
        });
        setDomains(arr);
    }

    useEffect(() => {
        loadAllDomains();
    }, [])

    return <RecoveryTable domains={domains}/>
}